import styled from "styled-components";

export const FormLogin = styled.form`
  @media (width <= 768px) {
    margin-top: 33%;
  }
`

export const TitleLogin = styled.span`
    font-family: 'Oxygen';
    font-style: normal;
    font-weight: 300;
    font-size: 40px;
    color: #0039C5;
    &.bold {
        font-weight: 700;
    }
`
export const SubtitleLogin = styled.span`
    font-family: 'Oxygen';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    color: #0039C5;
`
export const Observation = styled.p`
    font-family: 'Oxygen';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #6B6664;
    margin-bottom: 24px;
    span {
        font-weight: 700;
    }
`
export const HasAccount = styled.p`
    font-family: 'Oxygen';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #6B6664;
    button {
        border: none;
        background: transparent;
        width: fit-content;
        font-weight: 700;
        color: #0039C5;
        &:hover {
            cursor: pointer;
        }
    }
`